import { createWsActions, WsPrefixes, send } from '@skynet/data-ws-core';
import type { WsCommand } from '@skynet/data-ws-core';

export const prefix = WsPrefixes.assistantPrefix;

const assistantActions = createWsActions(prefix);

export const {
  actionConnect: actionAssistantConnect,
  actionOnOpen: actionAssistantOnOpen,
  actionDisconnect: actionAssistantDisconnect,
  actionOnClose: actionAssistantOnClose,
  actionOnClosed: actionAssistantOnClosed,
  actionSend: actionAssistantSend,
  actionOnMessage: actionAssistantOnMessage,
  actionOnBroken: actionAssistantOnBroken,
  actionOnReconnectBegin: actionAssistantOnReconnectBegin,
  actionOnReconnectAttempt: actionAssistantOnReconnectAttempt,
  actionOnReconnected: actionAssistantOnReconnected,
  actionOnError: actionAssistantOnError,
} = assistantActions;

export { assistantActions };

/** Dispatches a WS send action with the Assistant prefix. */
export const wsAssistantSend = (message: WsCommand) => send(message, prefix);
